/**
 * Shared Edit + Delete icon controls for hub upload rows.
 * Hidden until row hover/focus-within on pointer devices; always on for touch.
 */
import { Pencil, Trash2 } from 'lucide-react'
import type { HubInboxItem } from '../../api/types'
import './HubDocRowActions.css'

export default function HubDocRowActions({
  item,
  onEdit,
  onDelete,
  testIdPrefix = 'hub-doc',
}: {
  item: HubInboxItem
  onEdit: (item: HubInboxItem) => void
  onDelete: (item: HubInboxItem) => void
  testIdPrefix?: string
}) {
  const name = item.original_name || 'document'
  return (
    <span
      className="hub-row-actions"
      data-testid={`${testIdPrefix}-actions-${item.id}`}
      onClick={(e) => e.stopPropagation()}
      onKeyDown={(e) => e.stopPropagation()}
    >
      <button
        type="button"
        className="hub-row-action-btn"
        data-testid={`${testIdPrefix}-edit-${item.id}`}
        aria-label={`Edit ${name}`}
        title={`Edit ${name}`}
        onClick={() => onEdit(item)}
      >
        <Pencil size={16} strokeWidth={2} aria-hidden />
      </button>
      <button
        type="button"
        className="hub-row-action-btn hub-row-action-btn--delete"
        data-testid={`${testIdPrefix}-delete-${item.id}`}
        aria-label={`Delete ${name}`}
        title={`Delete ${name}`}
        onClick={() => onDelete(item)}
      >
        <Trash2 size={16} strokeWidth={2} aria-hidden />
      </button>
    </span>
  )
}
